import { Progress } from "@heroui/react";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import type { GetCustomerSubscription } from "@/server-types";
import {
  commitmentEndOfTermLabel,
  commitmentRemainingLabel,
  planTermLabel,
} from "@/pages/Dashboard/Subscriptions/commitmentPlanTerm";

type CustomerSubscription =
  GetCustomerSubscription["response"]["customerSubscription"];

type CustomerSubscriptionCommitmentTermProps = {
  commitment: CustomerSubscription["commitments"][number];
  durationValue: CustomerSubscription["durationValue"];
  durationUnit: CustomerSubscription["durationUnit"];
};

export function CustomerSubscriptionCommitmentTerm({
  commitment,
  durationValue,
  durationUnit,
}: CustomerSubscriptionCommitmentTermProps) {
  const endOfTermLabel = commitmentEndOfTermLabel(commitment);

  return (
    <div
      data-identifier="subscription-commitment"
      className="flex flex-col gap-1.5"
    >
      <p className="text-default-500 text-small">
        <Trans>Vezava</Trans>
        {": "}
        <span className="text-foreground">
          {planTermLabel(commitment.periods, durationValue, durationUnit)}
          {" · "}
          {t`${commitment.priceFormatted} na obdobje`}
        </span>
      </p>
      <p className="text-default-500 text-small">
        {commitment.firstPeriodStartFormatted} -{" "}
        {commitment.lastPeriodEndFormatted}
      </p>
      <Progress
        data-identifier="subscription-commitment-progress"
        aria-label={t`Napredek vezave`}
        size="sm"
        maxValue={commitment.periods}
        value={commitment.periodsServed}
      />
      <p className="text-default-500 text-tiny">
        {commitmentRemainingLabel(commitment)}
      </p>
      {endOfTermLabel ? (
        <p
          data-identifier="subscription-commitment-end-of-term"
          className={`text-tiny ${
            commitment.noticeGivenAt ? "text-warning" : "text-default-500"
          }`}
        >
          {endOfTermLabel}
        </p>
      ) : null}
    </div>
  );
}
